
import { AdminLayout } from '@/admin/components/AdminLayout';
import PnolDispatchesTable from '@/admin/components/pnol-dispatches/PnolDispatchesTable';

export default function PnolDispatchesPage() {
  return (
    <AdminLayout
      title="Desembolsos PNOL"
      subtitle="Lotes generados por el cron de desembolso. Operaciones envía el archivo a BCI y luego marca cada lote como enviado."
    >
      <div className="max-w-6xl">
        <div className="mb-6 rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm dark:border-blue-900 dark:bg-blue-950/30">
          <p className="text-blue-800 dark:text-blue-400">
            <span className="material-symbols-outlined mr-1 align-middle text-base">info</span>
            Cada noche el cron toma los adelantos aprobados y arma un archivo PNOL con una línea por adelanto. El archivo se sube a S3 y los adelantos pasan a estado <code>disbursed</code>. Operaciones descarga el archivo desde el detalle de cada lote, lo envía a BCI por el portal del banco y vuelve aquí a marcarlo como enviado.
          </p>
        </div>

        <PnolDispatchesTable />
      </div>
    </AdminLayout>
  );
}
